import React from 'react';
import { Link } from 'react-router-dom';
import './SettingsMenu.css';

const SettingsMenu = () => {
  return (
    <div className="settings-menu">
      <ul className="menu-items">
        <li className="menu-item">
          <Link to="/settings/waba-profile" className="menu-link">
            Waba Profile
          </Link>
        </li>
        <li className="menu-item">
          <Link to="/settings/contact-column" className="menu-link">
            Contact Column
          </Link>
        </li>
        <li className="menu-item">
          <Link to="/settings/common-message" className="menu-link">
            Common Message
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SettingsMenu;
